import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { graphql } from 'react-relay';

import StravaActivitiesSelection from './StravaActivitiesSelection';
import QueryHandler from '../../misc/QueryHandler';

const StravaActivitiesSelectionQueryRenderer = React.memo(
  ({
    accessToken,
    isAuthorizationError,
    noStravaActivitiesFoundCallback,
    fileSelectedManually,
    handleFileSelectedManuallyCallback,
    setUpStravaActivity,
    eventDates,
  }) => {
    const stableAccessToken = useMemo(() => accessToken, [accessToken]);

    return (
      <QueryHandler
        hasLoadingIndicator={false}
        query={graphql`
          query StravaActivitiesSelectionQueryRendererQuery(
            $accessToken: String!
            $hasStravaToken: Boolean!
            $before: Date
            $after: Date
          ) {
            stravaActivities(accessToken: $accessToken, before: $before, after: $after)
              @include(if: $hasStravaToken) {
              activities {
                distance
                elapsedTime
                id
                name
                startDate
              }
            }
          }
        `}
        variables={{
          accessToken: stableAccessToken,
          hasStravaToken: Boolean(stableAccessToken),
          before: eventDates.endsAt,
          after: eventDates.beginsAt,
        }}
        render={(props) => {
          return (
            <StravaActivitiesSelection
              stravaActivities={props.stravaActivities}
              isAuthorizationError={isAuthorizationError}
              noStravaActivitiesFoundCallback={noStravaActivitiesFoundCallback}
              fileSelectedManually={fileSelectedManually}
              handleFileSelectedManuallyCallback={handleFileSelectedManuallyCallback}
              setUpStravaActivity={setUpStravaActivity}
            />
          );
        }}
      />
    );
  }
);

StravaActivitiesSelectionQueryRenderer.propTypes = {
  accessToken: PropTypes.string,
};

export default StravaActivitiesSelectionQueryRenderer;
